import React, { Fragment } from "react";
import { graphql } from "gatsby";
import Block from "../../Block";
import { extractId, extractURL } from "utils/youtubeHelper";
import VideoThumbnail from "components/common/VideoThumbnail";

class CoreEmbedYoutube extends Block {
  render() {
    const { block } = this.props;

    // the replace to remove enclosing html is probably not needed but keeping it just in case
    const extractedUrl = extractURL(block)
    const videoId = extractId(extractedUrl)

    const videoUrl = `https://www.youtube.com/embed/${videoId}?feature=oembed&autoplay=1&rel=0`

    const video = {
      extFilename: `https://img.youtube.com/vi/${videoId}/0.jpg`,
      alt: "Youtube Video",
      intro: null,
      video: videoUrl,
      youtube: { videoId: videoId }
    };

    return <div className="text-center">
      <VideoThumbnail data={video} showPlayIcon={true} />
    </div>
  }
}

class CoreEmbedYoutubeFactory {
  get type() {
    return "core-embed/youtube";
  }

  create(props) {
    return <CoreEmbedYoutube {...props} />;
  }
}

export default CoreEmbedYoutubeFactory;
